import { NAV_FEATURES } from "./features.registry";

export const BUSINESS_FEATURES_WITH_HIERARCHY = {
    OTHERS: [
        {
            "id": NAV_FEATURES.DASHBOARD,
            "name": "Dashboard",
            "ui": {
                "hierarchy": {
                    "mainMenu": null,
                    "subMenu": null,
                    "level": 0,
                    "order": 0
                },
                "icons": {
                    "main": "Dashboard.svg"
                },
                "route": {
                    "path": "/home",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.ROUTES,
            "name": "Routes",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "User Setting",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "user-setting-icon.svg"
                },
                "route": {
                    "path": "/home/routes",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.FEATURES,
            "name": "Feature",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "User Setting",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "user-setting-icon.svg"
                },
                "route": {
                    "path": "/home/feature",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.SCREEN,
            "name": "Screen",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "User Setting",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "user-setting-icon.svg"
                },
                "route": {
                    "path": "/home/screen",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.SYNC,
            "name": "Sync",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "User Setting",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "user-setting-icon.svg"
                },
                "route": {
                    "path": "/home/aclsync",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.BUSINESS_CATEGORIES,
            "name": "Business Category",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "User Setting",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "user-setting-icon.svg"
                },
                "route": {
                    "path": "/home/businesscategory",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.BUSINESS_TYPES,
            "name": "Business Type",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "User Setting",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "user-setting-icon.svg"
                },
                "route": {
                    "path": "/home/businesstype",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.PERSON_ROLES,
            "name": "Person Role",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "User Setting",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "user-setting-icon.svg"
                },
                "route": {
                    "path": "/home/personrole",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.TRANSACTION_TYPES,
            "name": "Transaction Type",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Material",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "material-management-icon.svg"
                },
                "route": {
                    "path": "/home/transactiontype",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.UNITS_OF_MEASURES,
            "name": "Units of Measures",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Material",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "material-management-icon.svg"
                },
                "route": {
                    "path": "/home/uom",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.SHAPES,
            "name": "Shapes",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Material",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "material-management-icon.svg"
                },
                "route": {
                    "path": "/home/shapes",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.ITEM_TYPES,
            "name": "Item Types",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Material",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "material-management-icon.svg"
                },
                "route": {
                    "path": "/home/itemtype",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.CULTURE_CATEGORIES,
            "name": "Culture Categories",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/culturecategory",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.SPECIES_TYPES,
            "name": "Species Type",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/speciestype",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.WATER_TYPES,
            "name": "Water Type",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/watertype",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.SOIL_TYPES,
            "name": "Soil Type",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/soiltype",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.ACTIVITIES_LIST,
            "name": "Activity Types",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/activitieslist",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.BROOD_BREEDERS,
            "name": "Brood Breeders",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/broodbreederslist",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.BROOD_LINES,
            "name": "Brood Lines",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/broodlineslist",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.OBSERVATION_TYPES,
            "name": "Observation Types",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/observationtypeslist",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.TREATMENT_TYPES,
            "name": "Treatment Types",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/treatmenttypeslist",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.POND_TYPES,
            "name": "Pond Types",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/pondtypeslist",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.POND_USAGES,
            "name": "Pond Usages",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Aquaculture",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "aqua-culture-icon.svg"
                },
                "route": {
                    "path": "/home/pondusageslist",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.QUICK_REGISTRATION,
            "name": "Quick Registration",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Infra Setup",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "trading-community-icon.svg"
                },
                "route": {
                    "path": "/home/Quick-Registartion",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.BUSINESS_ENTITIES,
            "name": "Businesses",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Infra Setup",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "trading-community-icon.svg"
                },
                "route": {
                    "path": "/home/businesses",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.PERSONS,
            "name": "People",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": "Infra Setup",
                    "level": 2,
                    "order": 2
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "group": "trading-community-icon.svg"
                },
                "route": {
                    "path": "/home/Persons-List/People",
                    "params": [],
                    "queryParams": []
                }
            }
        }
    ],
    PROVIDER: [
        {
            "id": NAV_FEATURES.DASHBOARD,
            "name": "Dashboard",
            "ui": {
                "hierarchy": {
                    "mainMenu": null,
                    "subMenu": null,
                    "level": 0,
                    "order": 0
                },
                "icons": {
                    "main": "Dashboard.svg"
                },
                "route": {
                    "path": "/home/dashboard",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.YOUR_CUSTOMERS,
            "name": "Your Customers",
            "ui": {
                "hierarchy": {
                    "mainMenu": null,
                    "subMenu": null,
                    "level": 0,
                    "order": 1
                },
                "icons": {
                    "main": "your-customer-icon.svg"
                },
                "route": {
                    "path": "/home/customers",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.FARM_USERS,
            "name": "Farm Users",
            "ui": {
                "hierarchy": {
                    "mainMenu": null,
                    "subMenu": null,
                    "level": 0,
                    "order": 2
                },
                "icons": {
                    "main": "farm-user-icon.svg"
                },
                "route": {
                    "path": "/home/Persons-List/People",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.POND_METRICS,
            "name": "Pond",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Metrics",
                    "subMenu": null,
                    "level": 1,
                    "order": 3
                },
                "icons": {
                    "menu": "Metrics.svg"
                },
                "route": {
                    "path": "/home/farmpond",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.FEED_METRICS,
            "name": "Feed",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Metrics",
                    "subMenu": null,
                    "level": 1,
                    "order": 3
                },
                "icons": {
                    "menu": "Metrics.svg"
                },
                "route": {
                    "path": "/home/farmfeed",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.DENSITY_METRICS,
            "name": "Density",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Metrics",
                    "subMenu": null,
                    "level": 1,
                    "order": 3
                },
                "icons": {
                    "menu": "Metrics.svg"
                },
                "route": {
                    "path": "/home/farmstockingdensity",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.HARVEST_METRICS,
            "name": "Harvest",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Metrics",
                    "subMenu": null,
                    "level": 1,
                    "order": 3
                },
                "icons": {
                    "menu": "Metrics.svg"
                },
                "route": {
                    "path": "/home/farmharvest",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.WATER_QUALITY_METRICS,
            "name": "Water Quality",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Metrics",
                    "subMenu": null,
                    "level": 1,
                    "order": 3
                },
                "icons": {
                    "menu": "Metrics.svg"
                },
                "route": {
                    "path": "/home/farmwaterquality",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.SAMPLING_METRICS,
            "name": "Sampling",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Metrics",
                    "subMenu": null,
                    "level": 1,
                    "order": 3
                },
                "icons": {
                    "menu": "Metrics.svg"
                },
                "route": {
                    "path": "/home/farmsampling",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.WATER_QUALITY_READINGS_METRICS,
            "name": "Water Quality Readings",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Metrics",
                    "subMenu": null,
                    "level": 1,
                    "order": 3
                },
                "icons": {
                    "menu": "Metrics.svg"
                },
                "route": {
                    "path": "/home/historywaterquality",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.YOUR_BUSINESS,
            "name": "Your Business",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": null,
                    "level": 1,
                    "order": 4
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "main": "your-business-icon.svg"
                },
                "route": {
                    "path": "/home/business-profile",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.YOUR_FIELD_FORCE,
            "name": "Your Field Force",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": null,
                    "level": 1,
                    "order": 4
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "main": "your-filed-force-icon.svg"
                },
                "route": {
                    "path": "/home/Persons-List/Staff",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.PRODUCTS,
            "name": "Products",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": null,
                    "level": 1,
                    "order": 4
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "main": "product-icon.svg"
                },
                "route": {
                    "path": "/home/products",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.BARCODES,
            "name": "Barcode",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": null,
                    "level": 1,
                    "order": 4
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "main": "barcode-icon.svg"
                },
                "route": {
                    "path": "/home/addbarcode",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.ORDERS,
            "name": "Orders",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Manage",
                    "subMenu": null,
                    "level": 1,
                    "order": 4
                },
                "icons": {
                    "menu": "manage-icon.svg",
                    "main": "orders-icon.svg"
                },
                "route": {
                    "path": "/home/orders",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.VISITS,
            "name": "Visits",
            "ui": {
                "hierarchy": {
                    "mainMenu": null,
                    "subMenu": null,
                    "level": 0,
                    "order": 5
                },
                "icons": {
                    "main": "visitor.png",
                },
                "route": {
                    "path": "/home/visits",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.CULTURE_SUMMARY,
            "name": "Culture Summary",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Reports",
                    "subMenu": null,
                    "level": 1,
                    "order": 6
                },
                "icons": {
                    "menu": "Reports.svg",
                },
                "route": {
                    "path": "/home/culturesummaryreport",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.POND_SUMMARY,
            "name": "Pond Summary",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Reports",
                    "subMenu": null,
                    "level": 1,
                    "order": 6
                },
                "icons": {
                    "menu": "Reports.svg",
                },
                "route": {
                    "path": "/home/pondsummaryreport",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.DAY_SUMMARY,
            "name": "Day Summary",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Reports",
                    "subMenu": null,
                    "level": 1,
                    "order": 6
                },
                "icons": {
                    "menu": "Reports.svg",
                },
                "route": {
                    "path": "/home/daysummary",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.TRACEABILITY_SUMMARY,
            "name": "Traceability Summary",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Reports",
                    "subMenu": null,
                    "level": 1,
                    "order": 6
                },
                "icons": {
                    "menu": "Reports.svg",
                },
                "route": {
                    "path": "/home/traceabilityreport",
                    "params": [],
                    "queryParams": []
                }
            }
        },
        {
            "id": NAV_FEATURES.ACTIVITY_TRACKER_LEADS,
            "name": "Activity Tracker/Leads",
            "ui": {
                "hierarchy": {
                    "mainMenu": "Reports",
                    "subMenu": null,
                    "level": 1,
                    "order": 6
                },
                "icons": {
                    "menu": "Reports.svg",
                },
                "route": {
                    "path": "/home/activitytracker",
                    "params": [],
                    "queryParams": []
                }
            }
        }
    ],
}